import { queryOptions } from '@tanstack/react-query';
import { deviceAPIClient } from '../deviceAPIClient';
import { DEVICE_QUERY_KEYS } from './keys';
import type { GetGeoLocationRequest } from './types';

export const DEVICE_QUERIES = {
  getGeoLocation: (params: GetGeoLocationRequest) =>
    queryOptions({
      queryKey: DEVICE_QUERY_KEYS.geoLocation(params),
      queryFn: async () => deviceAPIClient.getGeoLocation(params),
      enabled: Boolean(params?.ip),
    }),
};
